import apiClient from './client';
import type {
  GameSession,
  SessionCheckResponse,
  SessionCreateRequest,
  SessionUpdateRequest,
} from '@business-game/shared';

export const sessionsApi = {
  /**
   * Get all sessions
   */
  async getAllSessions(activeOnly = false, includeArchived = false): Promise<GameSession[]> {
    const response = await apiClient.get('/sessions', {
      params: { active: activeOnly, includeArchived },
    });
    return response.data.data;
  },

  /**
   * Get session by code
   */
  async getSessionByCode(code: string): Promise<GameSession> {
    const response = await apiClient.get(`/sessions/code/${code}`);
    return response.data.data;
  },

  /**
   * Get session by ID
   */
  async getSessionById(id: number): Promise<GameSession> {
    const response = await apiClient.get(`/sessions/${id}`);
    return response.data.data;
  },

  /**
   * Check if session code is valid
   */
  async checkSession(code: string): Promise<SessionCheckResponse> {
    const response = await apiClient.get(`/sessions/check/${code}`);
    return response.data.data;
  },

  /**
   * Create a new session
   */
  async createSession(data: Omit<SessionCreateRequest, 'code'>): Promise<GameSession> {
    const response = await apiClient.post('/sessions', data);
    return response.data.data;
  },

  /**
   * Update a session
   */
  async updateSession(id: number, data: SessionUpdateRequest): Promise<GameSession> {
    const response = await apiClient.put(`/sessions/${id}`, data);
    return response.data.data;
  },

  /**
   * Archive a session
   */
  async archiveSession(id: number): Promise<void> {
    await apiClient.delete(`/sessions/${id}`);
  },

  /**
   * Permanently delete a session (super admin only)
   */
  async deleteSession(id: number): Promise<void> {
    await apiClient.post(`/sessions/${id}/delete`);
  },

  /**
   * Unarchive a session
   */
  async unarchiveSession(id: number): Promise<void> {
    await apiClient.post(`/sessions/${id}/unarchive`);
  },
};

